import { CruiseSaleModel } from 'api-hooks/sale/cruise';
import { Option } from 'baseui/select';
import { PreferenceFormSchema } from 'common/form-schema';
import * as Yup from 'yup';

export const CruiseSaleCruiseSaleAddOnsFormSchema = () =>
  Yup.object({
    id: Yup.string(),
    guestId: Yup.string().default(''),
    price: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .default(0),
    description: Yup.string().default(''),

    //addional information
    customId: Yup.string(),
    guestName: Yup.string().default(''),
  });

export const CruiseSaleCruiseSaleGuestFormSchema = () =>
  Yup.object({
    id: Yup.string(),
    preferences: Yup.array(PreferenceFormSchema()).default([]),
    guestId: Yup.string().default(''),

    //additional information
    customId: Yup.string(),
    guestName: Yup.string().default(''),
    guestPreferences: Yup.array(PreferenceFormSchema()).default([]),
    guestDetailId: Yup.string(), // just for relation indicator
  });

export const CruiseSaleCruiseSaleDetailsFormSchema = () =>
  Yup.object({
    id: Yup.string(),
    cruiseRoomNumber: Yup.string().default(''),
    deck: Yup.string().default(''),
    basicFare: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .default(0),
    portCharge: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .default(0),
    tax: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .default(0),
    tipping: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .default(0),
    description: Yup.string().default(''),
    guestId: Yup.string().default(''),
    cruiseRoomId: Yup.string().default(''),

    // additional information
    customId: Yup.string(),
    guestName: Yup.string().default(''),
    cruiseRoomName: Yup.string().default(''),
    guestDetailId: Yup.string(), // just for relation indicator
  });

export const CruiseSaleCruiseSaleFormSchema = () =>
  Yup.object({
    id: Yup.string(),
    customId: Yup.string(),
    cruiseId: Yup.string().default(''),
    cruiseShipId: Yup.string().default(''),
    bookingCode: Yup.string().default(''),
    startedAt: Yup.date().default(new Date()),
    endedAt: Yup.date().default(new Date()),
    route: Yup.string().default(''),
    isGroupedPrice: Yup.boolean().default(false),
    reminder: Yup.boolean().default(false),
    reminderDate: Yup.date().nullable().default(null),
    reminderDescription: Yup.string().nullable().default(''),
    cruiseSaleGuests: Yup.array(CruiseSaleCruiseSaleGuestFormSchema()).default(
      [],
    ),
    cruiseSaleDetails: Yup.array(
      CruiseSaleCruiseSaleDetailsFormSchema(),
    ).default([]),
    cruiseSaleAddOns: Yup.array(CruiseSaleCruiseSaleAddOnsFormSchema()).default(
      [],
    ),

    //additional information
    cruiseName: Yup.string().default(''),
    cruiseShipName: Yup.string().default(''),
  });

export const CruiseSaleFormSchema = () =>
  Yup.object({
    refId: Yup.string(),
    parentRefId: Yup.string(),
    transactionAt: Yup.date().default(new Date()),
    needApproval: Yup.boolean().default(false),
    code: Yup.string().default(''),
    description: Yup.string().default(''),
    adminId: Yup.string().default(''),
    operatorId: Yup.string().default(''),
    salesmanId: Yup.string().default(''),
    customerId: Yup.string().default(''),
    customerBillingId: Yup.string().default(''),
    discount: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .default(0),
    otherCost: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .default(0),
    total: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .default(0),
    cruiseSales: Yup.array(CruiseSaleCruiseSaleFormSchema()).default([]),

    //additional information
    tempTransactionAt: Yup.date().default(new Date()),
    phone: Yup.string().default(''),
    address: Yup.string().default(''),
    number: Yup.string().default(''),
    customerStatus: Yup.string().default(''),
    hasDueReceivable: Yup.boolean().default(false),
    remainingTransactionQuota: Yup.number().nullable().default(null),
    isExceedingQuota: Yup.boolean().default(false),
  });

export type CruiseSaleFormType = Yup.InferType<
  ReturnType<typeof CruiseSaleFormSchema>
> & {
  cruiseSale?: CruiseSaleModel;
  customerBillingOptions: Option[];
};

export type CruiseSaleCruiseSaleFormType = Yup.InferType<
  ReturnType<typeof CruiseSaleCruiseSaleFormSchema>
>;

export type CruiseSaleCruiseSaleGuestFormType = Yup.InferType<
  ReturnType<typeof CruiseSaleCruiseSaleGuestFormSchema>
>;

export type CruiseSaleCruiseSaleDetailsFormType = Yup.InferType<
  ReturnType<typeof CruiseSaleCruiseSaleDetailsFormSchema>
>;

export type CruiseSaleCruiseSaleAddOnsFormType = Yup.InferType<
  ReturnType<typeof CruiseSaleCruiseSaleAddOnsFormSchema>
>;
